export default __webpack_public_path__ + "static/media/9.67387399.jpg";